import {create} from 'zustand';
import {CONTRACT_TABLE_SEARCH_CATEGORIES} from '../constants/contract-table-search-categories.constants';

type SearchCategory = (typeof CONTRACT_TABLE_SEARCH_CATEGORIES)[number]['value'];

type SearchObject = Partial<Record<SearchCategory, string>>;

interface ContractTableSearchState {
  searchQuery: string;
  searchCategory: (typeof CONTRACT_TABLE_SEARCH_CATEGORIES)[number]['value'];
  search: () => SearchObject;

  setSearchQuery: (query: string) => void;
  setSearchCategory: (category: SearchCategory) => void;
}

export const useContractsTableSearchStore = create<ContractTableSearchState>((set, get) => ({
  searchQuery: '',
  searchCategory: CONTRACT_TABLE_SEARCH_CATEGORIES[0].value,

  search: () => {
    const {searchQuery, searchCategory} = get();
    return {[searchCategory]: searchQuery};
  },

  setSearchQuery: (query: string) => set({searchQuery: query.trim()}),
  setSearchCategory: (category: SearchCategory) => set({searchCategory: category}),
}));

export const {setSearchCategory, setSearchQuery} = useContractsTableSearchStore.getState();
